/* ==================================================================
   Aude Pluie — interactions PDP (vanilla, sans dépendance)
   - <ap-picker> : sélecteur d'options (pastilles Couleur + cartes Offre)
     -> résout la variante, met à jour le form, le prix CTA, la galerie,
     et diffuse `ap:offer-change`.
   - <ap-sticky> : barre ATC fixe mobile.
   - ap.initReviewFilter : lit ?concern= et pré-active le filtre avis.
   ===================================================================== */
(function () {
  'use strict';

  function money(cents) {
    var value = (cents / 100).toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return value + ' €';
  }

  // Prix compact pour les boutons de carte (style accueil) : "59 €" si euros ronds.
  function moneyShort(cents) {
    if (cents % 100 === 0) return cents / 100 + ' €';
    return money(cents);
  }

  /* ------------------------------ <ap-picker> ----------------------------- */
  class APPicker extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId) || document;
      this.variantInput = this.form.querySelector('.product-variant-id');
      var dataEl = this.querySelector('script[data-ap-variants]');
      try {
        this.variants = JSON.parse(dataEl ? dataEl.textContent : '[]');
      } catch (e) {
        this.variants = [];
      }
      this.radios = Array.from(this.querySelectorAll('input[type="radio"][data-option-name]'));
      this.radios.forEach((r) => r.addEventListener('change', () => this.update()));
      this.wireOfferCards();
      this.update(true);
    }

    // Cartes d'offres : cliquer la carte = offre active ; cliquer son bouton = active + ajout panier.
    // L'ajout réutilise la plomberie Dawn en déclenchant le bouton submit masqué (.ap-buybox__submit),
    // qui porte l'id de la variante Couleur × Offre courante (résolue par update()).
    wireOfferCards() {
      var self = this;
      this.querySelectorAll('[data-offer-card]').forEach(function (card) {
        var radio = card.querySelector('input[type="radio"]');
        var addBtn = card.querySelector('[data-ap-offer-add]');
        function activate() {
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        card.addEventListener('click', function (e) {
          if (e.target.closest('[data-ap-offer-add]')) return;
          activate();
        });
        if (addBtn) {
          addBtn.addEventListener('click', function (e) {
            e.preventDefault();
            if (addBtn.disabled) return;
            activate();
            var submit =
              (self.form && self.form.querySelector && self.form.querySelector('.ap-buybox__submit')) ||
              document.querySelector('.ap-buybox__submit');
            if (submit) submit.click();
          });
        }
      });
    }

    selectedOptions() {
      var opts = {};
      this.radios.forEach(function (r) {
        if (r.checked) opts[r.dataset.optionName] = r.dataset.value;
      });
      return opts;
    }

    currentVariant() {
      var opts = this.selectedOptions();
      return this.variants.find(function (v) {
        return Object.keys(opts).every(function (k) {
          return v.options[k] === opts[k];
        });
      });
    }

    update(silent) {
      var v = this.currentVariant();
      if (!v) return;
      if (this.variantInput) this.variantInput.value = v.id;

      // états visuels
      this.querySelectorAll('[data-offer-card]').forEach(function (c) {
        var input = c.querySelector('input[type="radio"]');
        c.classList.toggle('is-selected', !!(input && input.checked));
      });
      this.querySelectorAll('[data-ap-swatch]').forEach(function (s) {
        var input = s.querySelector('input[type="radio"]');
        s.classList.toggle('is-selected', !!(input && input.checked));
      });

      // prix des cartes d'offres recalculés pour la couleur active
      var opts = this.selectedOptions();
      var self = this;
      this.querySelectorAll('[data-offer-card]').forEach(function (card) {
        var input = card.querySelector('input[type="radio"]');
        if (!input) return;
        var probe = Object.assign({}, opts);
        probe[input.dataset.optionName] = input.dataset.value;
        var pv = self.variants.find(function (x) {
          return Object.keys(probe).every(function (k) { return x.options[k] === probe[k]; });
        });
        if (!pv) return;
        var priceEl = card.querySelector('[data-offer-price]');
        var compareEl = card.querySelector('[data-offer-compare]');
        var saveEl = card.querySelector('[data-offer-save]');
        if (priceEl) priceEl.textContent = money(pv.price);
        if (compareEl) {
          compareEl.textContent = pv.compare_at > pv.price ? money(pv.compare_at) : '';
          compareEl.hidden = !(pv.compare_at > pv.price);
        }
        if (saveEl) {
          if (pv.compare_at > pv.price) {
            saveEl.textContent = money(pv.compare_at - pv.price) + ' économisés';
            saveEl.hidden = false;
          } else {
            saveEl.hidden = true;
          }
        }
        // prix dans le bouton de la carte (style accueil), recalculé pour la couleur active
        var btnPriceEl = card.querySelector('[data-offer-btn-price]');
        var btnCompareEl = card.querySelector('[data-offer-btn-compare]');
        if (btnPriceEl) btnPriceEl.textContent = moneyShort(pv.price);
        if (btnCompareEl) {
          if (pv.compare_at > pv.price) {
            btnCompareEl.textContent = moneyShort(pv.compare_at);
            btnCompareEl.hidden = false;
          } else {
            btnCompareEl.textContent = '';
            btnCompareEl.hidden = true;
          }
        }
      });

      // CTA
      var priceText = money(v.price);
      var scope = this.form && this.form.querySelectorAll ? this.form : this;
      scope.querySelectorAll('[data-ap-cta-price]').forEach(function (el) {
        el.textContent = priceText;
      });
      document.querySelectorAll('[data-ap-headline-price]').forEach(function (el) { el.textContent = priceText; });
      document.querySelectorAll('[data-ap-headline-compare]').forEach(function (hc) {
        if (v.compare_at > v.price) { hc.textContent = money(v.compare_at); hc.hidden = false; } else { hc.hidden = true; }
      });

      // galerie : montrer le média de la variante (couleur)
      if (v.media_id && !silent) {
        var slide = document.querySelector('[data-media-id="' + v.media_id + '"]');
        var track = document.querySelector('[data-ap-gallery-track]');
        if (slide && track) {
          track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        }
      }

      var label = Object.values(this.selectedOptions()).join(' · ');
      document.dispatchEvent(
        new CustomEvent('ap:offer-change', {
          detail: { variantId: v.id, price: v.price, priceText: priceText, label: label },
        })
      );
    }
  }
  if (!customElements.get('ap-picker')) customElements.define('ap-picker', APPicker);

  /* ------------------- <ap-offers> (compat sections héritées) ------------ */
  class APOffers extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.formId) || document;
      this.variantInput = this.form.querySelector('.product-variant-id');
      this.radios = Array.from(this.querySelectorAll('input[type="radio"][data-variant-id]'));
      this.radios.forEach((r) => r.addEventListener('change', () => this.select(r)));
      var checked = this.querySelector('input[type="radio"]:checked') || this.radios[0];
      if (checked) this.select(checked, true);
    }
    select(radio) {
      if (!radio) return;
      var id = radio.dataset.variantId;
      var price = radio.dataset.price;
      var sp = radio.dataset.sellingPlan || '';
      if (this.variantInput && id) this.variantInput.value = id;
      // Abonnement vs achat unique : même variante, 2 modes -> on (dé)active l'input selling_plan.
      var spInput = this.form && this.form.querySelector ? this.form.querySelector('input[name="selling_plan"].ap-selling-plan-id') : null;
      if (spInput) {
        if (sp) { spInput.value = sp; spInput.disabled = false; }
        else { spInput.value = ''; spInput.disabled = true; }
      }
      this.querySelectorAll('[data-offer-card]').forEach(function (c) {
        c.classList.toggle('is-selected', c.contains(radio));
      });
      var priceText = money(parseInt(price, 10));
      var scope = this.form && this.form.querySelectorAll ? this.form : this;
      scope.querySelectorAll('[data-ap-cta-price]').forEach(function (el) {
        el.textContent = priceText;
      });
      var prefEl = scope.querySelector('[data-ap-cta-prefix]');
      if (prefEl) {
        prefEl.textContent = sp ? (this.dataset.labelSub || "S'abonner") : (this.dataset.labelBuy || 'Ajouter au panier');
      }
      document.querySelectorAll('[data-ap-headline-price]').forEach(function (el) { el.textContent = priceText; });
      // Label complet du vrai bouton (prefixe + prix), pour recopie sur la barre sticky.
      var ctaWrap = scope.querySelector('.ap-bundlesel__submit-label');
      var ctaLabel = ctaWrap ? ctaWrap.textContent.replace(/\s+/g, ' ').trim() : null;
      if (this.hasAttribute('data-primary')) {
        document.dispatchEvent(new CustomEvent('ap:offer-change', {
          detail: { variantId: id, price: price, priceText: priceText, label: radio.dataset.label, ctaLabel: ctaLabel },
        }));
      }
    }
  }
  if (!customElements.get('ap-offers')) customElements.define('ap-offers', APOffers);

  /* ----------------------------- <ap-sticky> ----------------------------- */
  class APSticky extends HTMLElement {
    connectedCallback() {
      this.watchEl = document.querySelector(this.dataset.watch || '#ap-buybox');
      this.submitSelector = this.dataset.submit || '.ap-buybox__submit';
      this.btn = this.querySelector('[data-ap-sticky-add]');

      if (this.btn) {
        this.btn.addEventListener('click', () => {
          var realBtn = document.querySelector(this.submitSelector);
          if (realBtn) realBtn.click();
        });
      }

      if ('IntersectionObserver' in window && this.watchEl) {
        this.io = new IntersectionObserver(
          (entries) => {
            var e = entries[0];
            this.toggle(!e.isIntersecting);
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0 }
        );
        this.io.observe(this.watchEl);
      }

      document.addEventListener('ap:offer-change', (e) => {
        var p = this.querySelector('[data-ap-sticky-price]');
        var l = this.querySelector('[data-ap-sticky-label]');
        if (p && e.detail.priceText) p.textContent = e.detail.priceText;
        if (l && e.detail.label) l.textContent = e.detail.label;
        // Recopie le label complet du vrai bouton sur le bouton de la barre (mode achat/abonnement).
        // Absent des pages sans mode (fiche pommeau via ap-picker) -> bouton de la barre inchange.
        if (this.btn && e.detail.ctaLabel) this.btn.textContent = e.detail.ctaLabel;
      });

      // Sync initial : la barre se connecte APRES <ap-offers>, donc elle rate le 1er ap:offer-change.
      // On recopie une fois le label du vrai bouton bundle (present uniquement sur la page recharges).
      var initLabel = document.querySelector('.ap-bundlesel__submit-label');
      if (this.btn && initLabel) this.btn.textContent = initLabel.textContent.replace(/\s+/g, ' ').trim();

      var drawer = document.querySelector('cart-drawer');
      if (drawer && 'MutationObserver' in window) {
        this.mo = new MutationObserver(() => {
          this.classList.toggle('ap-cart-open', drawer.classList.contains('active'));
        });
        this.mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
    }

    toggle(show) {
      this.classList.toggle('is-visible', show);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.mo) this.mo.disconnect();
    }
  }
  if (!customElements.get('ap-sticky')) customElements.define('ap-sticky', APSticky);

  /* ---------------------------- Filtre avis ?concern= --------------------- */
  function initReviewFilter() {
    var root = document.querySelector('[data-ap-reviews]');
    if (!root) return;
    var params = new URLSearchParams(window.location.search);
    var concern = params.get('concern');

    var buttons = Array.from(root.querySelectorAll('[data-concern]'));
    var items = Array.from(root.querySelectorAll('[data-review-concern]'));

    function apply(value) {
      buttons.forEach(function (b) {
        b.classList.toggle('is-active', b.dataset.concern === value);
        b.setAttribute('aria-pressed', b.dataset.concern === value);
      });
      items.forEach(function (it) {
        var tags = (it.dataset.reviewConcern || '').split(/\s+/);
        var match = value === 'all' || tags.indexOf(value) !== -1;
        it.hidden = !match;
      });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        apply(b.dataset.concern);
      });
    });

    apply(concern && buttons.some((b) => b.dataset.concern === concern) ? concern : 'all');
  }

  if (document.readyState !== 'loading') initReviewFilter();
  else document.addEventListener('DOMContentLoaded', initReviewFilter);

  window.AudePluie = { initReviewFilter: initReviewFilter };
})();
